module.exports = __webpack_public_path__ + "bgHeaderProduct.jpg?1fddd2d956ed585f946f51d237fafd63";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bgHeaderProduct.jpg
// module id = 85
// module chunks = 0